import Vue from 'vue';

import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import StorageService from '@/utils/storage-service';

// mutations declarations
export const SET_SELECTED_WORKFLOW_ID = 'SET_SELECTED_WORKFLOW_ID';
export const SET_CONTEXTUAL_LOADING = 'SET_CONTEXTUAL_LOADING';
export const SAVE_TRIGGER_BASE_URL = 'SAVE_TRIGGER_BASE_URL';
export const SET_PUBLISH_LOADING = 'SET_PUBLISH_LOADING';
export const SET_IS_INTERFACE_PREVIEW_ENABLED = 'SET_IS_INTERFACE_PREVIEW_ENABLED';

const storage = StorageService.getStorage();

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_SELECTED_WORKFLOW_ID](state, id) {
		Vue.set(state, 'selectedWorkflowId', id);
	},
	[SET_CONTEXTUAL_LOADING](state, value) {
		Vue.set(state, 'contextualLoading', value);
	},
	[SAVE_TRIGGER_BASE_URL](state, value) {
		Vue.set(state, 'triggerUrl', value);
	},
	[SET_PUBLISH_LOADING](state, value) {
		Vue.set(state, 'isPublishLoading', value);
	},
	[SET_IS_INTERFACE_PREVIEW_ENABLED](state, value) {
		storage.setItem('IS_INTERFACE_PREVIEW_ENABLED', value);
		Vue.set(state, 'isInterfacePreviewEnabled', value);
	},
};

export default mutations;
